import React from 'react'
import PasswordComponent from '../../components/Form/PasswordComponent'
import { useDispatch, useSelector } from 'react-redux'
import { Spinner } from '../../components'
import { clearAll, onChangePassword, setErrorMessageUser, setLoadingUser, showChangePasswordFormFunc } from '../../../config/redux/slice/appSlice'
import { useForm } from 'react-hook-form'
import { postRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'

export default function ChangePasswordModal() {
    const dispatch = useDispatch()
    const {register, unregister, handleSubmit, watch, getValues, setError, setValue, formState: {errors}, reset} = useForm({mode: 'onTouched'})
    
    const {
        token,
        userData,
        email
    } = useSelector((state) => state.authData)
    
    const {
    userLoading,
    userErrorMsg,
    userSuccessMsg,
} = useSelector((state) => state.app)

const passwordValue = watch('new_password')

const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showChangePasswordFormFunc({ modal: false }));
    };

  const onSubmit = async (data) => {
        dispatch(clearAll({}))
          const res = await postRequest(
              token,
              `${appApi.change_password}`,
              data,
              dispatch,
              setLoadingUser,
              "",
              setErrorMessageUser
          )
          if(res != undefined && res.status < 400){
            dispatch(onChangePassword({message: res.data.message}))
          }
        }    

  return (
     <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
      <form onSubmit={handleSubmit(onSubmit)} autoComplete={'off'} noValidate>
        <div className="modal-header px-4">
          <h6 className="modal-title" id="exampleModalCenterTitle">Change Password</h6>
          <button 
            type="button" 
            className="close" 
            data-dismiss="modal" 
            aria-label="Close"
            onClick={()=>{closeModal()}}
        >
          <span aria-hidden="true">×</span>
        </button>
        </div>
        <div className="modal-body px-4 px-md-7">
            <div className="row mb-2">

              <PasswordComponent
                fieldName={'old_password'}
                error_msg={errors.old_password?.message}
                label={'Old Password'}
                isReq={true}
                register={register}
                patternRules={''}
            />
            <PasswordComponent
                fieldName={'new_password'}
                error_msg={errors.new_password?.message}
                label={'New Password'}
                isReq={true}
                register={register}
                patternRules={'password'}
                hasHelperText={true}
            />

            <PasswordComponent
              fieldName={'password_confirmation'}
              error_msg={errors.password_confirmation?.message}
              label={'Confirm Password'}
              isReq={true}
              register={register}
              patternRules={'password'}
              isSameAs={passwordValue}
            />

            </div>

        </div>
        <div className="modal-footer px-4 d-flex align-items-center">
          <button disabled={userLoading ? true : false} type="button" className="btn btn-smoke" data-dismiss="modal">Cancel</button>
          <div>
          {userLoading ? 
            <Spinner/> :
            <button type="submit" className="btn btn-primary">Submit</button>
          }
        </div>
        </div>
      </form>
    </div>
  </div>
</div>
  )
}
